import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';
import { CoreEnums } from '@/utils/domain/constants';
import Filters, { registerModuleFilters } from '@/utils/input/filters';

const StartModeFilter = {
  ...Filters.BaseFilters.EnumFilter,
  name: 'startMode',
  label: 'processes.form.startMode',
  enumNamespace: getEnumNamespace(CoreEnums.ProcessStartMode),
  enumSource: CoreEnums.ProcessStartMode,
  options: createEnumOptions(CoreEnums.ProcessStartMode, 'processes.select'),
};

const ProcessGroupFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'processGroupId',
  label: 'global.text.processGroup',
  apiRoute: 'processGroup/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const IsPublicProcessFilter = {
  ...Filters.BaseFilters.BooleanFilter,
  name: 'isPublicProcess',
  label: 'global.text.isPublic',
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
};

export const filtersConfig = [
  StartModeFilter,
  ProcessGroupFilter,
  IsPublicProcessFilter,
  Filters.IsActiveFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
];

registerModuleFilters('processes', [StartModeFilter, ProcessGroupFilter, IsPublicProcessFilter]);
